// extracted by css-extract-rspack-plugin
module.exports =  {"root":"AvatarProgress__root___sh7Gq","progress":"AvatarProgress__progress___zfaA_"};